import posthog from 'posthog-js';
import { patchDomNodeRemoval } from './app/utils/patch-dom-node-removal';
import { getPostHogBrowserInitConfig } from '@instamenu/posthog/client';

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    ...getPostHogBrowserInitConfig(),
    // Editor captures share the browser budget with autocapture; keep the override
    // here so other apps retain the shared PostHog defaults.
    rate_limiting: {
      events_burst_limit: 200,
      events_per_second: 50,
    },
  });
}

patchDomNodeRemoval((details) => {
  if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    posthog.capture('dashboard_dom_parent_mismatch', details);
  }
});
